import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

/**
 * Stats rule for recording Rebound Net occurrences (Indoor Football).
 * Records attempted and outcome type (caught offense/defense, hit ground, fielded).
 */
export default class ReboundNetStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            FootballState.HitReboundNet === fragment.associatedState &&
            (play.historyContains(FootballState.ReboundNetCaughtOffense) ||
                play.historyContains(FootballState.ReboundNetCaughtDefense) ||
                play.historyContains(FootballState.ReboundNetHitGround) ||
                play.historyContains(FootballState.ReboundNetFieldedKicking) ||
                play.historyContains(
                    FootballState.ReboundNetFieldedReceiving
                )) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const caughtOffenseFragment = play.getFirstFragment(
            FootballState.ReboundNetCaughtOffense
        );
        const caughtDefenseFragment = play.getFirstFragment(
            FootballState.ReboundNetCaughtDefense
        );
        const hitGroundFragment = play.getFirstFragment(
            FootballState.ReboundNetHitGround
        );
        const fieldedKickingFragment = play.getFirstFragment(
            FootballState.ReboundNetFieldedKicking
        );
        const fieldedReceivingFragment = play.getFirstFragment(
            FootballState.ReboundNetFieldedReceiving
        );

        const stats = [];

        // Determine who to attribute the stat to based on context
        // For passes: use the passer
        // For kickoffs: use the kicker
        const passFragment = play.getFirstFragment(FootballState.Pass);
        const kickFragment = play.getFirstFragment(FootballState.Kick);

        let playerId = null;
        let teamId = null;
        let fragmentId = null;

        if (passFragment) {
            playerId = passFragment.passedBy?.id;
            teamId = passFragment.passedBy?.teamId;
            fragmentId = passFragment.id;
        } else if (kickFragment) {
            playerId = kickFragment.kickedBy?.id;
            teamId = kickFragment.kickedBy?.teamId;
            fragmentId = kickFragment.id;
        }

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId,
                playerId,
                driveId: gameContext.currentDriveId,
                fragmentId,
                category: FootballStatsCategory.REBOUND_NET,
                values: {
                    attempted: 1,
                    caughtOffense: caughtOffenseFragment ? 1 : 0,
                    caughtDefense: caughtDefenseFragment ? 1 : 0,
                    hitGround: hitGroundFragment ? 1 : 0,
                    fieldedKicking: fieldedKickingFragment ? 1 : 0,
                    fieldedReceiving: fieldedReceivingFragment ? 1 : 0
                }
            },
            stats
        );

        return stats;
    }
}
